import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseKey) {
  throw new Error('Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY — set them in .env or Vercel environment');
}

export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    // Pin the storage key so sessions survive API key migrations or env var changes.
    storageKey: 'tecc-auth-session',

    // LOCK FIX: Bypass navigator.locks entirely.
    // Supabase uses the Web Locks API to prevent concurrent auth operations across
    // tabs. In a single-tab SPA this is unnecessary and causes "lock not released
    // within 5000ms" errors when a previous page navigation leaves a lock held in
    // a dead browsing context — the new page load steals it with the 'steal' option,
    // aborting any in-flight getSession/refreshSession calls with AbortError.
    // Replacing with a no-op lock that immediately invokes the callback eliminates
    // the lock contention entirely while retaining all auth functionality.
    lock: (_name, _acquireTimeout, fn) => fn(),
  }
});
